<template>
  <layout-content>
    <v-btn
      v-if="user.role !== 'user'"
      slot="top-buttons"
      class="top-buttons"
      fab
      dark
      small
      color="#394858"
      @click="create_project"
    >
      <v-icon dark>
        mdi-plus
      </v-icon>
    </v-btn>
    <table-component />
  </layout-content>
</template>

<script>
  import TableComponent from '@projects/components/projects-table.vue';
  import { mapGetters } from 'vuex';
  import { IntegrateModalService } from '@administration/modals/IntegrateModalService';

  export default {
    components: { TableComponent },
    computed: {
      ...mapGetters('core/auth', ['integrate']),
      ...mapGetters('core/auth', ['user'])
    },
    methods: {
      create_project() {
        this.integrate ?
          this.$router.push({ name: 'projects.create' }):
          IntegrateModalService.create()
      }
    }
  }
</script>

<style lang="scss">
  .page-content {
    position: relative;
  }
</style>
